import Vue from 'vue'
import {
  TabBar,
  tabPanels,
  Slide,
  Scroll,
  Loading
} from 'cube-ui'

Vue.use(TabBar)
Vue.use(tabPanels)
Vue.use(Slide)
Vue.use(Scroll)
Vue.use(Loading)



// WEBPACK FOOTER //
// ./src/util/cube-ui.js